import { Container, Texture } from '../../../odie';

import {
  KappaBlockProps,
  ModeBlockOptionDef,
  blockPropsMap,
} from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

// constants
//-------------------------------------------------------------------------
const manifest = {
  hard: 'kappa/block.kappa.0.png',
  soft: 'kappa/block.kappa.1.png',
};

/*
    kappa block view
*/
export class KappaBlockView extends Container {
  private _sprite: FitWidthBlockSprite;

  public set statusSprite(status: 'hard' | 'soft') {
    // update texture
    this._sprite.texture = Texture.from(manifest[status]);
  }

  // init
  //-------------------------------------------------------------------------
  constructor(props: KappaBlockProps) {
    // create base view
    super();
    this._sprite = new FitWidthBlockSprite(manifest.hard, props);
    this.addChild(this._sprite);
    blockPositionView(this, props);
  }

  public static assets(): string[] {
    return Object.values(manifest);
  }

  public setOption(option: number) {
    const props = blockPropsMap.kappa.options![option] as ModeBlockOptionDef;
    this.statusSprite = props.mode;
  }
}
